import request from '@/utils/request'


// 获取大洲国家
export function continent() {
  return request({
    url: '/language/continent',
    method: 'post'
  })
}

// 获取国家语言列表
export function language(data) {
  return request({
    url: "/language/list",
    method: 'post',
	data:new URLSearchParams(data).toString()
  })
}
// export function language(data) {
//   return request({
//     url: `/language/list?country=${data}`,
//     method: 'post'
//   })
// }

